import { A } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { throwIfAlreadyLoaded } from 'src/app/core/guard/module-import.guard';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';

interface Row {
  name: string;
  items: number[];
}
export interface SelectedTimeRange {
  dayOfWeek: string;
  start: string;
  end: string;
}


@Component({
  selector: 'app-coaching-availability',
  templateUrl: './coaching-availability.component.html',
  styleUrls: ['./coaching-availability.component.scss']
})
export class CoachingAvailabilityComponent implements OnInit, OnDestroy {

  @Output()
  times = new EventEmitter<any[]>();

  @Input()
  user: User;

  @Input()
  selectedTimeRange: SelectedTimeRange[] = [];

  preselectedTimes: any[][];
  weekDays: [] = [];
  hours = new Array(24).fill(0, 0, 23)
  hCells = new Array(7).fill(0)
    .map((n, index) => index + 1);

  arr: Row[] = [
    { name: 'Sunday', items: new Array(24).fill(0) },
    { name: 'Monday', items: new Array(24).fill(0) },
    { name: 'Tuesday', items: new Array(24).fill(0) },
    { name: 'Wednesday', items: new Array(24).fill(0) },
    { name: 'Thursday', items: new Array(24).fill(0) },
    { name: 'Friday', items: new Array(24).fill(0) },
    { name: 'Saturday', items: new Array(24).fill(0) },
  ];
  subscriptionRef:Subscription;
  
  constructor(private authService: AuthService, private changeDetectorRef: ChangeDetectorRef) { }
  
  ngOnDestroy(): void {
   this.subscriptionRef.unsubscribe();
  }

  ngOnInit(): void {
    this.arr.forEach((row, index) => {
      this.weekDays[row.name] = index;
    });
    console.log(this.weekDays)
    this.subscriptionRef = this.authService.currentUser.pipe(take(1)).subscribe(data => {
      if (data !== undefined && data !== null) {
        if (data?.timeRanges) {
          this.populateTimes(data?.timeRanges);
          // this.times.emit(data.timeRanges);
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  populateTimes(ranges: any) {
    console.log(ranges);
    this.preselectedTimes = new Array(7)
      .fill(false)
      .map(() =>
        new Array(24).fill(false)
      );
    for (let range of ranges) {
      const weekIdx = this.weekDays[range.dayOfWeek];
      console.log('r ', range, ' ', weekIdx)
      for (let i = range.start; i <= range.end; i++) {
        this.preselectedTimes[weekIdx][i] = true;
        this.arr[weekIdx].items[i] = i;
      }
    }
  }

  getTime(time: number, format: string) {
    var hours = time;
    var AmOrPm = hours >= 12 ? 'pm' : 'am';
    hours = (hours % 12) || 12;
    if (format == '12hour') {
      return `${hours}:00 ${AmOrPm}`;
    } else {
      return time + ':00';
    }
  }

  getIsChecked(day: number, time: number) {
    if (this.preselectedTimes) {
      return this.preselectedTimes[day][time];
    }
  }

  click(day: number, time: number, event: any) {
    this.selectedTimeRange = [];
    this.arr[day].items[time] = time;
    let timeSelected = false;
    let lastSelectedTime = '';
    let currentDate = undefined;
    for (let i = 0; i < this.arr.length; i++) {
      for (let j = 0; j < this.arr[i].items.length; j++) {
        if (j === time && i === day && !event.checked) {
          continue;
        }
        if (this.arr[i].items[j] > 0 && !timeSelected) {
          currentDate = { dayOfWeek: this.arr[i].name, start: this.arr[i].items[j].toString(), end: this.arr[i].items[j].toString() };
          lastSelectedTime = this.arr[i].items[j].toString();
          timeSelected = true;
        } else if (this.arr[i].items[j] === 0 && timeSelected) {
          currentDate.end = lastSelectedTime;
          if (currentDate.start == currentDate.end) {
            currentDate.end = +currentDate.end + 1;
          }
          this.selectedTimeRange.push(currentDate);
          timeSelected = false;
        }
        else if (timeSelected) {
          lastSelectedTime = this.arr[i].items[j].toString();
        }
      }
    }
    this.times.emit(this.selectedTimeRange);
  }

}
